<template>
    <Row class="m-3">
        <template v-for="child in (isHome ? stateAppLayout?.menuSides : menuSideComputed?.children)" :key="child.id">
            <Col :xs="{ span: 24 }" :md="{ span: 8 }" class="p-3">
                <router-link :to="child.path">
                    <Card :bodyStyle="{ padding: '1em' }" class="shadow">
                        <div class="d-flex">
                            <div class="my-auto" v-if="child.meta?.icon">
                                <CIcon :file="child.meta.icon" class="mr-2 text-16"></CIcon>
                            </div>
                            <div class="my-auto">
                                <div class="text-16">{{ child.meta?.title }}</div>
                            </div>
                        </div>
                    </Card>
                </router-link>
            </Col>
        </template>
    </Row>
</template>

<script>
import { computed, defineAsyncComponent, defineComponent } from "vue";
import { state as stateAppLayout, getMenuByUrl } from "../../components/layout/app-layout/app-layout.logic";
import router from "../../router";
import { Row, Col, Card } from "ant-design-vue";
import lodash from "lodash";

export default defineComponent({
    components: {
        Row,
        Col,
        Card,
        CIcon: defineAsyncComponent(() => import("../../components/icon/CIcon")),
    },
    setup() {
        const menuSideComputed = computed(() => lodash.last(getMenuByUrl(stateAppLayout.menuSides, router.currentRoute.value.path)));
        const isHome = router.currentRoute.value.path === "/app/home";

        return {
            menuSideComputed,
            stateAppLayout,
            isHome
        };
    },
});
</script>